import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M16 3l0 4","key":"svg-1"}],["path",{"d":"M8 3l0 4","key":"svg-2"}],["path",{"d":"M4 11l16 0","key":"svg-3"}],["path",{"d":"M8 15h2v2h-2l0 -2","key":"svg-4"}]]

const IconCalendarEvent = createReactComponent('outline', 'calendar-event', 'CalendarEvent', __iconNode);

export default IconCalendarEvent;